import { render, staticRenderFns } from "./MobileTutorialDetail.vue?vue&type=template&id=6d4ab86c&scoped=true"
import script from "./MobileTutorialDetail.vue?vue&type=script&lang=js"
export * from "./MobileTutorialDetail.vue?vue&type=script&lang=js"
import style0 from "./MobileTutorialDetail.vue?vue&type=style&index=0&id=6d4ab86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ab86c",
  null
  
)

export default component.exports